/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCreateMessageForAddformModel,
  ICreateMessageForAddformRequest,
  IMappers,
  ICreateMessageForAddformResponse,
  ICreateMessageForAddformResponseError,
  TCreateMessageForAddformResponse,
} from './types';

const defaultConfig: TCreateMessageForAddformModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'demand',
  pathApi: '/v2/create-message-for-addform/',
  hostType: 'api',
} as TCreateMessageForAddformModel;

function createCreateMessageForAddformModel(
  parameters: ICreateMessageForAddformRequest,
): TCreateMessageForAddformModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateMessageForAddformOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICreateMessageForAddformRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCreateMessageForAddform<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICreateMessageForAddformOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCreateMessageForAddformResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCreateMessageForAddformModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateMessageForAddformResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICreateMessageForAddformResponseError);
    }
  }

  return { response, statusCode } as TCreateMessageForAddformResponse;
}

export { defaultConfig, createCreateMessageForAddformModel, fetchCreateMessageForAddform };
